<section class="tip-card" role="dialog" aria-labelledby="titulo">
    <!-- Columna izquierda -->
    <div class="aside">

        <div class="avatar" aria-label="Icono del paso">
            <img [src]="current.imageUrl" [alt]="current.title" />
        </div>
    </div>

    <!-- Columna derecha -->
    <div class="content">
        <!--   <button class="close" type="button" aria-label="Cerrar" (click)="onClose()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button> -->

        <!-- Título y descripción del paso actual -->
        <h6 id="titulo" class="title font-weight-bold mb-2">{{ current.title }}</h6>
        <p class="desc">{{ current.description }}</p>
        <ul class="desc">
            <li *ngFor="let item of current.items">{{ item }}</li>
        </ul>

        <div class="actions">
            <button class="link btn btn-white-border-reda-1" (click)="onClose()">{{ 'Omitir' }}</button>
            <button class="btn btn-white-border-reda-1" type="button" (click)="$event.preventDefault(); onLinkBack()" *ngIf="currentIndex > 0">{{ 'Atrás' }}</button>
            <button class="btn btn-navegacion-reda" type="button" (click)="$event.preventDefault(); onNext();">{{ linkLabel }}</button>
        </div>
    </div>
</section>